import { useRouteMatch } from "react-router-dom";

const useHeader = () => {
  const match = useRouteMatch("/:tipo");
  const matchAvaluo = useRouteMatch("/avaluo/gracias/");
  const matchReserva = useRouteMatch("/reserva/:reservationId/");
  const matchTestDrive = useRouteMatch("/test-drive/");
  const matchTestDriveG = useRouteMatch("/test-drive/gracias/");
  const matchTestDriveRvsp = useRouteMatch("/test-drive/reserva/:reservationId");
  const matchCotizar = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/cotizar/');
  const matchCotizarGracias = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/cotizar/gracias-por-cotizar');
  const matchRvsp = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/reservar/');
  const matchRvspProcessing = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/reservar/procesando');
  const matchTestDriveC = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/test-drive/');
  const matchTestDriveD = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/test-drive/gracias/');
  
  return match?.isExact 
    || matchAvaluo?.isExact 
    || matchReserva?.isExact 
    || matchTestDrive?.isExact 
    || matchTestDriveRvsp?.isExact
    || matchCotizar?.isExact
    || matchCotizarGracias?.isExact
    || matchRvsp?.isExact
    || matchTestDriveC?.isExact
    || matchTestDriveG?.isExact
    || matchTestDriveD?.isExact
    || matchRvspProcessing?.isExact;
};

export default useHeader;